import { render, staticRenderFns } from "./howto.vue?vue&type=template&id=064107ea&"
import script from "./howto.vue?vue&type=script&lang=js&"
export * from "./howto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports